import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Navbar as BootstrapNavbar,
  Nav,
  Modal,
  Button,
  Dropdown,
} from "react-bootstrap";
import { useTranslation } from "react-i18next";

const Navbar = () => {
  const [userName, setUserName] = useState(sessionStorage.getItem("userName"));
  // const [balance, setBalance] = useState(sessionStorage.getItem('balance'));
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const handleStorageChange = () => {
      const loggedIn = sessionStorage.getItem("loggedIn") === "true";
      if (loggedIn) {
        setUserName(sessionStorage.getItem("userName"));
        // setBalance(sessionStorage.getItem('balance'));
      } else {
        setUserName(null);
        // setBalance(null);
      }
    };

    window.addEventListener("storage", handleStorageChange);
    // window.addEventListener('balanceUpdated', handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      // window.removeEventListener('balanceUpdated', handleStorageChange);
    };
  }, []);

  const handleLogout = () => {
    sessionStorage.clear();
    localStorage.removeItem("user_id");
    localStorage.removeItem("login_time");
    setUserName(null);
    // setBalance(null);
    setShowLogoutModal(false);
    navigate("/");
  };

  const handleShowLogoutModal = () => setShowLogoutModal(true);
  const handleCloseLogoutModal = () => setShowLogoutModal(false);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <>
      <BootstrapNavbar
        expand="lg"
        className="modern-navbar"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          zIndex: 1050,
          background: "linear-gradient(135deg, #1c40f5 0%, #70a9ff 100%)",
          backdropFilter: "blur(10px)",
          borderBottom: "none",
          boxShadow: "0 4px 20px rgba(28, 64, 245, 0.2)",
          height: "64px",
          padding: "0",
        }}
      >
        <div className="container-fluid" style={{ height: "100%" }}>
          <div style={{ display: "flex", alignItems: "center", height: "100%" }}>
            <BootstrapNavbar.Brand
              as={Link}
              to="/"
              style={{
                fontWeight: "700",
                fontSize: "1.5rem",
                color: "#fff",
                textDecoration: "none",
                display: "flex",
                alignItems: "center",
                height: "100%",
              }}
            >
              <span
                style={{
                  background: "linear-gradient(45deg, #60d8ff, #3b82f6)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  marginRight: "8px",
                }}
              >
                ✦
              </span>
              Janney AI
            </BootstrapNavbar.Brand>
            {/* 新建Campaign按钮，仅在已登录时显示，国际化 */}
            {userName && (
              <Button
                variant="outline-light"
                className="ms-3"
                onClick={() => navigate("/new_campaign")}
                style={{
                  border: "2px solid rgba(255,255,255,0.3)",
                  borderRadius: "20px",
                  background: "rgba(255,255,255,0.1)",
                  backdropFilter: "blur(10px)",
                  fontWeight: "600",
                  padding: "8px 20px",
                  color: "#fff",
                  transition: "all 0.3s ease",
                  marginLeft: "16px"
                }}
              >
                + {t('new_campaign')}
              </Button>
            )}
          </div>
          <BootstrapNavbar.Toggle
            aria-controls="navbar-nav"
            style={{ border: "none", color: "#fff" }}
          />
          <BootstrapNavbar.Collapse id="navbar-nav">
            <Nav className="me-auto"></Nav>

            <div
              className="d-flex align-items-center"
              style={{ height: "100%" }}
            >
              <Dropdown className="me-3">
                <Dropdown.Toggle
                  variant="outline-light"
                  id="dropdown-language"
                  style={{
                    border: "2px solid rgba(255,255,255,0.3)",
                    borderRadius: "20px",
                    background: "rgba(255,255,255,0.1)",
                    backdropFilter: "blur(10px)",
                    fontWeight: "500",
                    fontSize: "0.9rem",
                    padding: "8px 16px",
                  }}
                >
                  Language | 语言
                </Dropdown.Toggle>
                <Dropdown.Menu
                  style={{
                    borderRadius: "12px",
                    border: "none",
                    boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
                    backdropFilter: "blur(10px)",
                    background: "rgba(255,255,255,0.95)",
                  }}
                >
                  <Dropdown.Item
                    onClick={() => changeLanguage("en")}
                    style={{ borderRadius: "8px", margin: "4px" }}
                  >
                    English
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => changeLanguage("zh")}
                    style={{ borderRadius: "8px", margin: "4px" }}
                  >
                    中文
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>

              {userName ? (
                <Dropdown align="end">
                  <Dropdown.Toggle
                    variant="outline-light"
                    id="dropdown-account"
                    style={{
                      border: "2px solid rgba(255,255,255,0.3)",
                      borderRadius: "20px",
                      background: "rgba(255,255,255,0.1)",
                      backdropFilter: "blur(10px)",
                      fontWeight: "600",
                      padding: "8px 16px",
                    }}
                  >
                    <span style={{ marginRight: "8px" }}>👤</span>
                    {userName}
                  </Dropdown.Toggle>
                  <Dropdown.Menu
                    style={{
                      borderRadius: "12px",
                      border: "none",
                      boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
                      backdropFilter: "blur(10px)",
                      background: "rgba(255,255,255,0.95)",
                    }}
                  >
                    <Dropdown.Item
                      as={Link}
                      to="/update_user"
                      style={{ borderRadius: "8px", margin: "4px" }}
                    >
                      {t("update_account")}
                    </Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item
                      onClick={handleShowLogoutModal}
                      style={{
                        borderRadius: "8px",
                        margin: "4px",
                        color: "#e74c3c",
                      }}
                    >
                      {t("logout")}
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              ) : (
                <Button
                  variant="outline-light"
                  onClick={() => navigate("/login")}
                  style={{
                    border: "2px solid rgba(255,255,255,0.3)",
                    borderRadius: "20px",
                    background: "rgba(255,255,255,0.1)",
                    backdropFilter: "blur(10px)",
                    fontWeight: "600",
                    padding: "8px 20px",
                    transition: "all 0.3s ease",
                  }}
                >
                  {t("login")}
                </Button>
              )}
            </div>
          </BootstrapNavbar.Collapse>
        </div>
      </BootstrapNavbar>

      <Modal
        show={showLogoutModal}
        onHide={handleCloseLogoutModal}
        centered
        style={{ backdropFilter: "blur(5px)" }}
      >
        <Modal.Header
          closeButton
          style={{
            background: "linear-gradient(135deg, #1c40f5 0%, #70a9ff 100%)",
            color: "#fff",
            border: "none",
            borderRadius: "12px 12px 0 0",
          }}
        >
          <Modal.Title style={{ fontWeight: "600" }}>
            {t("confirm_logout")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "24px", fontSize: "1.1rem" }}>
          <p style={{ margin: 0, color: "#555" }}>{t("logout_prompt")}</p>
        </Modal.Body>
        <Modal.Footer style={{ border: "none", padding: "16px 24px" }}>
          <Button
            variant="outline-secondary"
            onClick={handleCloseLogoutModal}
            style={{ borderRadius: "20px", padding: "8px 20px" }}
          >
            {t("cancel")}
          </Button>
          <Button
            variant="primary"
            onClick={handleLogout}
            style={{
              background: "linear-gradient(135deg, #e74c3c 0%, #c0392b 100%)",
              border: "none",
              borderRadius: "20px",
              padding: "8px 20px",
            }}
          >
            {t("confirm")}
          </Button>
        </Modal.Footer>
      </Modal>

      <style>{`
        body { padding-top: 64px; }
        .modern-navbar .navbar-toggler {
          border: none !important;
        }
        .modern-navbar .navbar-toggler:focus {
          box-shadow: none !important;
        }
      `}</style>
    </>
  );
};

export default Navbar;
